// const env = process.env.NODE_ENV

// const isJD = document.domain.includes("jdcloud-elite")

let hostName = window.location.host.split(".")
hostName[0] = "dmp"
export const API = process.env.REACT_APP_API_JD_DMP
export const JD_API = process.env.REACT_APP_API_JD
export const AUTH_URL = process.env.REACT_APP_URL_AUTH
export const APPID = process.env.REACT_APP_APPID
export const AUTH_URL_JD = process.env.REACT_APP_URL_AUTH_JD
export const APPID_JD = process.env.REACT_APP_APPID_JD
export const LOCATION_API = process.env.REACT_APP_API_JD_LOCATION

export const POI_API = process.env.REACT_APP_API_POI
export const IMG_URL =
  "https://s3.cn-northwest-1.amazonaws.com.cn/wz-dmp-image/"
export const PRODUCT_URL = window.location.protocol + "//" + hostName.join(".")
export const TEMP_REPORT = {
  target_id: "34",
  report: {
    live_report:
      "https://s3.cn-northwest-1.amazonaws.com.cn/wz-dmp-image/img/2019/03/2b13786f-b496-4ffb-8fc0-6e2a2048ca08.jpg",
    work_report:
      "https://s3.cn-northwest-1.amazonaws.com.cn/wz-dmp-image/img/2019/03/d05e8c2d-c2c7-47d5-950e-9ebe4ff087c6.jpg"
  }
}
export const STORE_SHORT_REPORT = {
  1114: "https://s3.cn-northwest-1.amazonaws.com.cn/wz-dmp-image/img/2019/04/be8a6ea4-03f0-4b83-a7e1-3052e0fd252f.jpg",
  8128: "https://s3.cn-northwest-1.amazonaws.com.cn/wz-dmp-image/img/2019/04/7b08177b-5376-4415-8c69-4074a59e2b7a.jpg"
}
export const COOKIE_DOMAIN = window.location.host
  .replace(/:\d+$/, "")
  .replace(/^[\w-]+/, "")

export const WEEKEND_UV = ["11001", "11061"] // 平安周末
export const MYJ = ["91004"] // 美宜佳
export const WHITE_LIST = [
  "jingyu.qiu",
  "yolanda.zhao",
  "cissie.wang",
  "nancy.yan",
  "martin.gao",
  "aaron.qi",
  "alvin.wang",
  "wangyi.xie",
  "dajurs.dai",
  "mark.wang",
  "cici.jia",
  "Jessica.zhou",
  "srinivas",
  "zhi.fu",
  "ys.yu",
  "gary.fu",
  "slash.tang",
  "sophia.yang",
  "jason.chen",
  "raymond.lei",
  "18017875535",
  "15900010001",
  "15900010002",
  "18664669967",
  "15112341234"
]

export const API_INSIGHTS = process.env.REACT_APP_API_INSIGHTS